<template>
    <b-row v-if="combosCarregados && contrato !== undefined" class="ml-1 d-flex align-items-start">
        <b-col cols="12">
            <b-row class="d-flex align-items-start">
                <b-col cols="12">
                    <default-form-validation-provider label="UG Responsável" v-slot="defaultState">
                        <b-form-select id="select-licitacao" v-model="idUg" :options="listaUgs" @change="carregarLicitacoesOutraUg"
                            :state="defaultState.state">
                        </b-form-select>
                    </default-form-validation-provider>
                    <default-form-validation-provider v-if="idUg !== null && combosCarregados" label="Licitação" v-slot="defaultState" tag="div">
                        <div id="licitacaoSelectWrapper" class="wrapper-multiselect-sagres"
                            :class="{ 'invalid': licitacaoSelecionada?.IdLicitacao === null, 'valid': licitacaoSelecionada?.IdLicitacao !== null }">
                            <multiselect v-model="licitacaoSelecionada" close-on-select searchable
                                :show-labels="false" label="Text" deselect-label="" :allow-empty="true"
                                placeholder="Selecione" track-by="IdLicitacao" :options="listaLicitacoes"
                                class="w-100" :state="defaultState.state" @input="procedimentoOrigemAtualizado">
                                <template slot="noOptions">
                                    <small><i>Nenhuma licitação cadastrada</i></small>
                                </template>
                                <template slot="noResult">
                                    <i>Nenhuma licitação encontrada</i>
                                </template>
                            </multiselect>
                        </div>
                    </default-form-validation-provider>
                </b-col>
            </b-row>
        </b-col>
    </b-row>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { store } from "@/store"
import { UtilsTS } from '@/utilsts'
import { Contrato } from '@/types/licitacoes/contratos/contrato'
import DefaultFormValidationProvider from '@/components/shared/DefaultFormValidationProvider.vue'
import contratoService from '@/services/licitacoes/contratoService'
import Multiselect from 'vue-multiselect'

const CompProps = Vue.extend({
    name: 'EditarProcedimentoOrigemDispensaLicitacaoOutraUg',
    components: { DefaultFormValidationProvider, Multiselect },
    props: {
        ctr: {
            type: Object,
            required: true
        }
    }
})

@Component
export default class EditarProcedimentoOrigemLicitacaoOutraUg extends mixins(UtilsTS, CompProps) {
    idUg: number | null = null;
    contrato: Contrato = new Contrato()
    combosCarregados = false
    listaLicitacoes: any[] | null = null
    listaUgs: any[] | null = null
    licitacaoSelecionada: any = null

    async mounted() {
        try {
            store.blockScreen = true
            this.contrato = this.ctr
            this.idUg = this.contrato.ContratoLicitacaoOutraUg ? this.contrato.ContratoLicitacaoOutraUg?.IdUnidGestoraLicit : null
            const responseUgs = await contratoService.listarUgsMunicipio();
            this.listaUgs = [{ value: null, text: 'SELECIONE', disabled: true }, ...responseUgs.data.map(u => ({ value: u.CodUgSagres, text: u.NmNome }))]
            if(this.idUg) {
                await this.carregarLicitacoesOutraUg()
            } else {
                this.combosCarregados = true
            }
        } catch (e: any) {
            console.error('Problema ao montar o componente EditarProcedimentoOrigemLicitacaoOutraUg', e)
        } finally {
            store.blockScreen = false
        }
    }

    async carregarLicitacoesOutraUg() {
        try {
            this.combosCarregados = false
            store.blockScreen = true
            this.licitacaoSelecionada = null
            if(this.idUg === this.contrato.ContratoLicitacaoOutraUg?.IdUnidGestoraLicit) {
                this.licitacaoSelecionada = {
                    IdLicitacao: null,
                    NrLicitacao: this.contrato.NrLicitacao, 
                    NrAnoLicitacao: this.contrato.NrAnoLicitacao, 
                    IdModalidade: this.contrato.IdModalidade,
                }
            }
            const responseLicitacoes = await contratoService.listarLicitacoesOutraUG(Number(this.idUg));
            this.listaLicitacoes = [{ IdLicitacao: null, Text: 'SELECIONE' }, ...responseLicitacoes.data.map(l => {
                return {
                    IdLicitacao: l.IdLicitacao,
                    NrLicitacao: l.NrLicitacao, 
                    NrAnoLicitacao: l.NrAnoLicitacao, 
                    IdModalidade: l.IdModalidade,  
                    Text: `${l.NrLicitacao}/${l.NrAnoLicitacao} ${l.DeModalidade} - ${l.DeObjetoLicitacao}`
                }
            })]
            if(this.licitacaoSelecionada !== null) {
                const licitacaoEncontrada = this.listaLicitacoes
                                                .find(l => l.NrLicitacao === this.licitacaoSelecionada.NrLicitacao
                                                        && l.NrAnoLicitacao === this.licitacaoSelecionada.NrAnoLicitacao
                                                        && l.IdModalidade === this.licitacaoSelecionada.IdModalidade)
                this.licitacaoSelecionada = licitacaoEncontrada 
            }
            this.combosCarregados = true
            
        } catch (e: any) {
            console.error('Problema no EditarProcedimentoOrigemLicitacaoOutraUg.carregarLicitacoesOutraUg', e)
        } finally {
            store.blockScreen = false
        }
    }

    procedimentoOrigemAtualizado() {
        this.contrato.IdUnidGestoraLicit = Number(this.idUg)
        this.contrato.NrLicitacao = this.licitacaoSelecionada.NrLicitacao
        this.contrato.NrAnoLicitacao = this.licitacaoSelecionada.NrAnoLicitacao
        this.contrato.IdModalidade = this.licitacaoSelecionada.IdModalidade

        this.$emit('input', this.contrato)
    }
}


</script>

<style scoped>
    :deep(svg) {
        padding-bottom: 0.75em;
    }

    :deep(#licitacaoSelectWrapper.invalid .multiselect__tags) {
        border: #dc3545 solid 1px !important;
        border-radius: 3px !important;
    }

    :deep(#licitacaoSelectWrapper.valid .multiselect__tags) {
        border: #28a745 solid 1px !important;
        border-radius: 3px !important;
    }

    :deep(#licitacaoSelectWrapper label) {
        width: 100%;
        margin-top: 0.25rem;
        font-size: 80%;
        color: #dc3545;
        text-align: left;
    }
</style>